// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Fragment } from 'react';
import '../../styles/containers/Party.css';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { FormControl, ControlLabel } from 'react-bootstrap';
import SimpleSelect from '../utils/FormWidgets/SimpleSelect';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import {
  StyledFilterFormGroup,
  StyledFilterTitle,
  StyledFilterWrapper,
} from '../utils/Styles/FilterStyles';

import AutoCompleteSearch from '../utils/AutoCompleteSearch';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-unused-modules
export class FilteredData {
  productId = null;
  partyLocation = null;
  rating = null;
}

class State {
  filteredData = new FilteredData();
}

export default class RnrsActivityForm extends React.Component {
  state = new State();

  componentDidMount() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { filterData } = this.props;
    if (filterData) {
      this.setState({ filteredData: filterData });
    }
  }

  handleTitleChange = ({ target }) => {
    let { filteredData } = this.state;
    filteredData = {
      ...filteredData,
      productId: target.value,
    };
    this.setState({ filteredData });
    if (target.value.length >= 3 || target.value.length === 0) {
      this.handleSubmit(filteredData);
    }
  };

  locationChanged = ({ value }) => {
    let { filteredData } = this.state;
    filteredData = {
      ...filteredData,
      partyLocation: value,
    };
    this.setState({ filteredData });
    this.handleSubmit(filteredData);
  };

  commonChange = (key, value) => {
    let { filteredData } = this.state;
    filteredData = {
      ...filteredData,
      [key]: value,
    };
    this.setState({ filteredData });
    this.handleSubmit(filteredData);
  };

  handleSubmit = async filteredData => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { filteredReviews } = this.props;
    filteredReviews(filteredData);
  };

  clear = () => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { clear } = this.props;
    this.setState({ filteredData: new FilteredData() });
    clear();
  };

  isEmptyPartyLocation = () => {
    const { filteredData } = this.state;
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    return !filteredData.partyLocation?.length;
  };

  render() {
    const { filteredData } = this.state;
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { cities, isMobileFilterSelected } = this.props;

    return (
      <Fragment>
        <div
          className={`form-content horizontal-form  filter-form ${
            isMobileFilterSelected ? 'mobile-filter-selected' : ''
          }`}
          style={{ paddingLeft: '0px' }}
        >
          <StyledFilterTitle>Filters</StyledFilterTitle>
          <StyledFilterWrapper>
            <StyledFilterFormGroup>
              <FormControl
                type='text'
                placeholder='Product id (3 characters min)'
                onChange={this.handleTitleChange}
                value={filteredData.productId || ''}
              />
            </StyledFilterFormGroup>
            <StyledFilterFormGroup
              controlId='partyLocation'
              style={{
                paddingLeft: '0px',
                display: 'inline-block',
                width: '300px',
              }}
            >
              {
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                <AutoCompleteSearch
                  placeholder='Start typing to select city'
                  // TODO: Fix this the next time the file is edited.
                  // eslint-disable-next-line react/prop-types
                  datalist={cities.map(city => ({
                    value: city.name,
                    label: `${city.name} ${
                      city.status === 'active' ? '' : '(deactive)'
                    }`,
                  }))}
                  clearText={this.isEmptyPartyLocation()}
                  itemValuePropName='label'
                  onComplete={this.locationChanged}
                />
              }
            </StyledFilterFormGroup>
          </StyledFilterWrapper>
          <StyledFilterFormGroup controlId='Rating'>
            <ControlLabel>Rating:</ControlLabel>
            <SimpleSelect
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              onChange={value => this.commonChange('rating', value)}
              value={filteredData.rating}
              placeholder=''
              data={[
                { label: '1', value: 1 },
                { label: '2', value: 2 },
                { label: '3', value: 3 },
                { label: '4', value: 4 },
                { label: '5', value: 5 },
              ]}
            />
            <button
              type='button'
              onClick={this.clear}
              className='btn btn-def panel-button'
              style={{
                verticalAlign: 'top',
                marginTop: '5px',
              }}
            >
              Clear all
            </button>
          </StyledFilterFormGroup>
        </div>
      </Fragment>
    );
  }
}
